import { State } from 'redux/rootReducer'

export const isAuthorizedSelector = (state: State) =>
  !!state.global.token && state.global.isDefaultPasswordChanged
